import { ChangeDetectionStrategy, Component, EventEmitter, Output } from '@angular/core';
import { UntypedFormControl, UntypedFormGroup } from '@angular/forms';
import { IsavValidators } from '../../../utils/forms/validators';
import { RegisterPersonCommandDto } from '../../../core/dto/register-person-command';

@Component({
    selector: 'isav-people-register-form',
    templateUrl: './people-register-form.html',
    styleUrls: ['./people-register-form.sass'],
    changeDetection: ChangeDetectionStrategy.OnPush,
})
export class PeopleRegisterForm {
    @Output() save = new EventEmitter<Partial<RegisterPersonCommandDto>>();

    form = new UntypedFormGroup({
        fullName: new UntypedFormControl(null, [IsavValidators.required('Full name is required!')]),
        email: new UntypedFormControl(null, [
            IsavValidators.required('Email is required!'),
            IsavValidators.email('Email is not valid'),
        ]),
        password: new UntypedFormControl(null),
        phone: new UntypedFormControl(null, [IsavValidators.required('Phone is required!')]),
        userProfileType: new UntypedFormControl(null, [
            IsavValidators.required('User profile type is required!'),
        ]),
        description: new UntypedFormControl(null, [
            IsavValidators.required('Description is required!'),
        ]),
        organisationLink: new UntypedFormControl(null),
        address: new UntypedFormControl(null),
        zipcode: new UntypedFormControl(null),
        city: new UntypedFormControl(null),
        country: new UntypedFormControl(null, [IsavValidators.required('Country is required!')]),
        location: new UntypedFormControl(null, [
            IsavValidators.required('Location is required!'),
            IsavValidators.coordinates(),
        ]),
        fieldOfInterests: new UntypedFormControl(null),
        linksToCV: new UntypedFormControl(null),
        profileImage: new UntypedFormControl(null, [
            IsavValidators.required('Profile image is required!'),
        ]),
        organisation: new UntypedFormControl(null, [
            IsavValidators.required('You need to select organisation!'),
        ]),
        receivingNewsletter: new UntypedFormControl(false),
        gpdrConsented: new UntypedFormControl(false),
        expertises: new UntypedFormControl(
            null,
            IsavValidators.notEmpty('You must select at least one topic!')
        ),
    });

    onSave() {
        this.save.emit({
            ...this.form.value,
        });
    }
}
